import {UserType} from "./UserTypes";
import {Patient} from './Patient';
import {Doctor} from './Doctor';

export interface User {
	id: string;
	email: string;
	typeUser?: UserType; 
}

export function isPatient(user: Patient | Doctor | null): user is Patient {
  return (user as Patient).hasFilledPersonalInformation !== undefined;
}
